<template>
  <div class="left-menu-list">
    <el-menu
      background-color="#001529"
      text-color="#fff"
      active-text-color="#fff"
      style="width:210px;text-align:left"
      :default-active="$route.meta.activeMenu || $route.path"
      router
    >
      <sidebar-item v-for="item in authMenus" :key="item.path" :item="item"/>
    </el-menu>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'
import constUtil from '@/utils/constUtil'

export default {
  data() {
    return {}
  },
  components: {SidebarItem},
  computed: {
    // 符合el-menu菜单的一个数据，返回显示在菜单栏的数据
    authMenus() {
      const menus = this.$store.getters.menus
      return this.getAuthMenus(menus)
    },
  },
  created() {
  },
  methods: {
    getAuthMenus(menus) {
      if (!menus || menus.length === 0) {
        return [];
      }
      const routes = [];
      menus.forEach(item => {
        const element = item.element
        if (element.menuType === constUtil.MENU_TYPE.MENU.key) {
          // === 1 时为菜单，其他为仅路由
          const route = {
            path: element.target,
            title: element.menuName,
          };
          if (item.children) {
            route.children = this.getAuthMenus(item.children)
          }
          routes.push(route)
        }
      })

      return routes
    }
  },

}
</script>

<style lang="less">
@import './index.less';
</style>



// WEBPACK FOOTER //
// src/components/leftMenu/index.vue